import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Clock } from 'lucide-react';
import { toast } from 'sonner';
import { errorMessage, get, post } from '@/lib/api';
import { cls } from '@/lib/format';

interface Me {
  /** The employee file behind this login (none: HR has not linked one yet). */
  employee: { id: string; fullName: string; employeeNo: string } | null;
  open: { clockIn: string } | null;
  upcoming: { id: string; startsAt: string; endsAt: string }[];
}
const hhmm = (iso: string) => new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Lagos', hour: '2-digit', minute: '2-digit' }).format(new Date(iso));

/** Clock in / out from the top bar; shows when the shift started. */
export function ClockButton() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['attendance-me'], queryFn: () => get<Me>('/attendance/me'), refetchInterval: 5 * 60_000 });
  if (!data?.employee) return null;
  const on = !!data.open;
  const next = data.upcoming[0];
  return (
    <button
      className={cls('hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg px-2.5 py-1 text-[12px] font-medium ring-1 sm:flex', on ? 'bg-emerald-50 text-emerald-800 ring-emerald-200 hover:bg-emerald-100' : 'bg-white text-slate-700 ring-slate-200 hover:bg-slate-50')}
      title={on ? 'Clock out at the end of your shift' : next ? `Next shift ${hhmm(next.startsAt)}–${hhmm(next.endsAt)}` : 'Clock in'}
      onClick={async () => {
        if (on && !window.confirm('Clock out now?')) return;
        try {
          await post('/attendance/clock', { action: on ? 'OUT' : 'IN' });
          toast.success(on ? 'Clocked out' : 'Clocked in');
          void qc.invalidateQueries({ queryKey: ['attendance-me'] });
        } catch (e) {
          toast.error(errorMessage(e));
        }
      }}
    >
      <Clock className="size-3.5" />
      {on ? `On shift since ${hhmm(data.open!.clockIn)}` : 'Clock in'}
    </button>
  );
}
